function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaterFilterPressureDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2663",
    d: "M20 8.129A17.778 17.778 0 1 1 2.222 25.907 17.8 17.8 0 0 1 20 8.129m0-2.222a20 20 0 1 0 20 20 20 20 0 0 0-20-20",
    transform: "translate(.5 -5.407)",
    style: {
      stroke: "transparent",
      strokeMiterlimit: 10,
      fill: "#ff7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2664",
    d: "M19.126 12.326A14.324 14.324 0 0 0 8.041 17.55l1.2 1.179a12.663 12.663 0 0 1 19.89.149l1.2-1.179a14.317 14.317 0 0 0-11.2-5.372",
    transform: "translate(1.317 -6.682)",
    style: {
      stroke: "transparent",
      strokeMiterlimit: 10,
      fill: "#ff7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2665",
    d: "M18.53 18.192a7.583 7.583 0 0 0-6.3 3.373l1.214 1.214a5.879 5.879 0 0 1 10.271.169l1.219-1.221a7.578 7.578 0 0 0-6.4-3.535",
    transform: "translate(1.914 -6.026)",
    style: {
      stroke: "transparent",
      strokeMiterlimit: 10,
      fill: "#ff7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2666",
    d: "M18.743 15.259a10.8 10.8 0 0 0-8.61 4.3l1.179 1.179a9.14 9.14 0 0 1 14.974.149l1.179-1.179a10.8 10.8 0 0 0-8.721-4.446",
    transform: "translate(1.7 -6.353)",
    style: {
      stroke: "transparent",
      strokeMiterlimit: 10,
      fill: "#ff7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2758",
    d: "M7.5 10.5v6l3-3v-3zM0 3l7.5 6h3L18 3zm0-1.5h18V0H0z",
    transform: "translate(11.236 19)",
    style: {
      fill: "#ff7600"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterFilterPressureDrop);
export default __webpack_public_path__ + "static/media/water-filter-pressure-drop.c6c5c73bfd8570e0c995638feb5f1723.svg";
export { ForwardRef as ReactComponent };